import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  n: '1',
  title: '⬇️ Sofortiger Download',
  desc: 'Kaufe und erhalte sofortigen Zugriff auf das komplette eBook und alle 5 Boni. Starte, wann du möchtest, keine Wartezeit.'
}, {
  n: '2',
  title: '👁️ Folge der visuellen Methode',
  desc: 'Lerne Hangeul, Aussprache, Vokabeln und Sätze in einer Reihenfolge, die dafür sorgt, dass du dich nie verlierst. Das System ist deine Roadmap.'
}, {
  n: '3',
  title: '🎯 Schließe die 60-Minuten-Routine ab',
  desc: 'Studiere Schritt für Schritt, übe, was du gelernt hast, und festige dein Gedächtnis, um mit echtem Selbstvertrauen in 60 Minuten zu sprechen.'
}];
export function Steps() {
  return <section aria-label="So funktioniert es" className="bg-transparent" data-id="element-159" data-mp="fppgtc4oc0uy">
      <div className="mx-auto max-w-4xl px-5 py-12" data-id="element-160" data-mp="262wqz1eyj513">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-161" data-mp="2a3gldx85bujj">
          🚀 So wirst du ab heute Fortschritte machen
        </h2>
        <p className="mt-3 text-center text-sm text-plum/60" data-id="element-162" data-mp="1q9rce4aof897">In 3 einfachen Schritten</p>

        <ol className="mt-10 space-y-4" data-id="element-163" data-mp="1lbhg1qd7u1m0">
          {steps.map((s, i) => <motion.li key={s.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-4 rounded-2xl border border-grape/15 bg-white p-5" data-id="element-164" data-mp="201eyrqsdlz3t" data-mpi={i}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-grape font-display text-base font-black text-white" data-id="element-165" data-mp="1haxl8tg47a31">
                {s.n}
              </span>
              <div data-id="element-166" data-mp="2spb2vgk9ytam">
                <h3 className="text-base font-bold text-plum" data-id="element-167" data-mp="2sorno7m0ej0a">{s.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-168" data-mp="2nr9bm8cp3no2">{s.desc}</p>
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}